import React from "react"
import {Button, Pane, PlusIcon} from "evergreen-ui";
import FilterRow from "./FilterRow";


export default function FiltersPanel({
     constructor,
     filters,
     isFullInfo,
     onAddFilterButton,
     deleteRowAction,
     datasourceTypes,
     selectDatasourceTypeAction,
     selectDatasourceAction,
     selectCodeAction,
     selectEntityAction,
     selectOperationAction
}) {

    const isStationSet = constructor.station.id != -1


    return (
        <Pane>
            <Pane display="flex" marginBottom={15} marginTop={-10} verticalAlign="center">
                <Pane paddingTop={5} paddingRight={10}>
                    {
                        isFullInfo ? <></> :
                            <Button
                                iconAfter={PlusIcon}
                                appearance={"primary"}
                                disabled={!isStationSet || filters.length >= 20}
                                onClick={() => onAddFilterButton()}
                            >
                                Новый тип источника
                            </Button>
                    }
                </Pane>
            </Pane>

            {filters.map(row => <FilterRow
                constructor={constructor}
                isFullInfo={isFullInfo}
                rowId={row.rowId}
                filters={filters}
                deleteFilterAction={deleteRowAction}
                datasourceFilterTypes={datasourceTypes}
                selectFilterDatasourceTypeAction={selectDatasourceTypeAction}
                selectFilterDatasourceAction={selectDatasourceAction}
                selectFilterCodeAction={selectCodeAction}
                selectEntityAction={selectEntityAction}
                selectOperationFilterAction={selectOperationAction}
            />)}
        </Pane>
    )
}